import {Lang} from 'yougile-lang'
import {
  Hub,
  StickerType,
  Tag,
  TimerStickerEntry,
  TimerStickerValue
} from 'yougile-model'
import {Time, TimeInterval} from 'yougile-util'
import {globals} from '../../globals-base'
import {Sticker} from '../sticker'
import {TimerCtl} from './timer-ctl'
import {StickerContainerKey} from '../views-web/a-sticker-view'

export class StopwatchCtl extends TimerCtl {
  public override onPinEmpty(
    task: Hub,
    sticker: Tag,
    container: StickerContainerKey
  ): void {
    const defaultVal: TimerStickerValue = {
      current: {
        by: globals.currentUserId,
        running: true,
        time: '0s',
        timestamp: Time.now()
      },
      history: []
    }
    Sticker.pin(sticker, container, task, defaultVal)
  }

  public override get title(): string {
    return 'Stopwatch'
  }

  public override get type(): StickerType {
    return 'stopwatch'
  }

  public override displayedTitle(_: Tag): string {
    return Lang.msg.stopwatch
  }

  /**
   * Time moves in the opposite direction in comparison with Timer.
   */
  public override intervalFrom(timestamp: number): TimeInterval {
    return TimeInterval.fromDates(timestamp, Time.now())
  }

  public override formatTime(value: TimerStickerEntry): string {
    return TimerCtl.formatEntry(value, false)
  }
}
